import { useCallback } from "react";
import { LicenseManagerApi, useAPIAction } from "melco-shared-logic";
import { useTranslation } from "react-i18next";

export interface LicenseManagerUpgradeInterface {
  email_address?: string;
  serial_number?: string;
  step: number;
  version_id?: string;
  subscription_code?: string;
  product_code?: string;
  referral_code?: string;
  assign_license?: boolean;
  melco_customer_id?: string | null;
  language?: string | null;
}

export const useLicenseManagerUpgrade = () => {
  const { t } = useTranslation();
  const [LicenseManagerUpgrade] = useAPIAction(
    LicenseManagerApi,
    async (
      api,
      LicenseManagerUpgradeDetails: LicenseManagerUpgradeInterface
    ) => {
      let data = await api.licenseManagerLicensesManagerUpgrade({
        controlcenterMelcoModelsUpgradeLicense: {
          email_address: LicenseManagerUpgradeDetails.email_address,
          serial_number: LicenseManagerUpgradeDetails.serial_number,
          step: LicenseManagerUpgradeDetails.step,
          subscription_code: LicenseManagerUpgradeDetails.subscription_code,
          version_id: LicenseManagerUpgradeDetails.version_id,
          referral_code: LicenseManagerUpgradeDetails.referral_code,
          product_code: LicenseManagerUpgradeDetails.product_code,
          assign_license: LicenseManagerUpgradeDetails.assign_license,
          melco_customer_id: LicenseManagerUpgradeDetails.melco_customer_id,
          language: LicenseManagerUpgradeDetails.language,
        },
      });

      return {
        successMessages:
          LicenseManagerUpgradeDetails.step == 3
            ? [{ message: "default" }]
            : [],
        data,
      };
    },
    {
      skipErrorHandling: true,
      translationPrefix: "licensemanager.upgrade",
    }
  );

  return useCallback(
    async (LicenseManagerUpgradeDetails: LicenseManagerUpgradeInterface) => {
      return await LicenseManagerUpgrade(LicenseManagerUpgradeDetails);
    },
    [LicenseManagerUpgrade]
  );
};
